module.exports = __webpack_public_path__ + "img/16_pc.1a3fadff.gif";